__turbopack_context__.v({
  "label": "IdField-module-scss-module__6q0q2G__label",
  "value": "IdField-module-scss-module__6q0q2G__value",
  "wrap": "IdField-module-scss-module__6q0q2G__wrap",
});
